import { render, staticRenderFns } from "./QuestionErrors.vue?vue&type=template&id=1e404de1&"
import script from "./QuestionErrors.vue?vue&type=script&lang=js&"
export * from "./QuestionErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports